import { render, staticRenderFns } from "./TheHeaderWebTutor.vue?vue&type=template&id=5e0c3608&scoped=true&"
import script from "./TheHeaderWebTutor.vue?vue&type=script&lang=js&"
export * from "./TheHeaderWebTutor.vue?vue&type=script&lang=js&"
import style0 from "./TheHeaderWebTutor.vue?vue&type=style&index=0&id=5e0c3608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0c3608",
  null
  
)

export default component.exports